import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import Preloader from "./components/Preloader.js";
import { ThemeProvider } from "./ThemeProvider";
import { HelmetProvider } from "react-helmet-async";

const RootComponent = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000); // Simulate loading time
  }, []);

  return loading ? <Preloader /> :
    <App />;
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <BrowserRouter>
      <ThemeProvider>
        <RootComponent />
      </ThemeProvider>
    </BrowserRouter>
  </HelmetProvider>
);